import resetState from './default';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = () => {
  return resetState.getDefaultState();
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/contract/index.js